import {
    JOB_CATEGORY,
    UPDATE_CATEGORY,
    SUBMIT_REQUISITION,
    ADDITIONAL_REQUIRMENT,
    LOCAL_BENEFIT,
    UPDATE_BENEFIT,
    REQUISITION_LIST,
    REQUISITION_ITEM,
    ENTITIES,
    LOGIN_SUCCESS,
    UNAUTHORIZE,
    LOADING,
    JOB_DESCRIPTION,
    JOB_REQUIRMENT,
    FORM_RESET,
    LOAD_BENEFIT,
    CATEGORY_LIST
} from '../actions/ActionType'

const INITIAL_STATE = {
    loading: false,
    login_success: false,
    unauthorize: false,
    category: [],
    category_list: [],
    list:[],
    entities: [],
    item: null,
    requirements: '',
    benefits:[],
    expat: '',
    submit: false,
    job_description: '',
    job_requirment: ''
}

export default (state= INITIAL_STATE, action) => {

    switch(action.type) {
        case FORM_RESET:
            return {...state, loading: false, category: [], list:[]}
        case JOB_CATEGORY:
            return {...state, category: [ ...state.category, action.payload]}
        case UPDATE_CATEGORY:
            return {...state, category: state.category.filter(category => category !== action.payload)}
        case SUBMIT_REQUISITION:
            return{...state, submit: action.payload}
        case ADDITIONAL_REQUIRMENT:
            return {...state, requirements: action.payload}
        case CATEGORY_LIST:
            return {...state, category_list: action.payload}
        case LOAD_BENEFIT:
            return {...state, benefits: action.payload}
        case LOCAL_BENEFIT:
            const new_benefit = [...state.benefits]

            const index =  state.benefits.indexOf(action.payload)

            if(index  === -1){
                new_benefit.push(action.payload)
            }else{
                new_benefit.splice(index, 1)
            }

        return {...state, benefits: new_benefit}
        
        case UPDATE_BENEFIT:
            return {...state, benefits: state.benefits.filter( benefit => benefit !== action.payload)}
       
        case REQUISITION_LIST:
            return {...state, list: action.payload}
        case REQUISITION_ITEM:
            return {...state, item: action.payload}
        case ENTITIES:
            return {...state, entities: action.payload}
        case LOGIN_SUCCESS: 
            return {...state, login_success: action.payload}
        case UNAUTHORIZE:
            return {...state, unauthorize: action.payload, login_success: false}
        case LOADING:
            return {...state, loading: action.payload}
        case JOB_DESCRIPTION:
            return {...state, job_description: action.payload}
        case JOB_REQUIRMENT:
            return {...state, job_requirment: action.payload}
        default:
            return state
    }

}